<template>
  <div class="add_apply">
    <head-top head-title="申请小区后台" go-back="true"></head-top>
    <div class="add_main">
      <div class="choice_village">
        <div class="choice_left" @click="choiceVillage">
          <span>选择小区：</span>
          <input type="text" readonly placeholder="请选择小区" v-model="villgeWord">
        </div>
        <img src="../home/images/fanhui1@2x.png" alt="">
      </div>
      <div class="bas_time" @click="openPicker()">
        <div class="choice_left">
          <span>结束时间：</span>
          <input type="text" v-model="endTime" placeholder="请选择结束时间" readonly>
        </div>
        <img src="../home/images/fanhui1@2x.png" alt="">
      </div>
      <!--小区弹窗-->
      <mt-popup
        v-model="villageShow"
        popup-transition="popup-fade" class="villageHeights">
        <div class="village">
          <p class="p border-bottom">请选择小区</p>
          <div class="plot-wrapper">
            <div class="search">
              <div class="search-wrapper">
                <input type="text" placeholder="请输入小区的名称" v-model="keyword" @keyup.enter="search" @input="search">
                <span class="search-icon" @click="search"></span>
              </div>
            </div>
          </div>
        </div>
        <mt-index-list>
          <mt-index-section :index="index" v-for="(item,index) in data" :key="index">
            <div v-for="(list,index) in item" @click="goVillage(list)">
              <mt-cell :title="list.title"></mt-cell>
            </div>
          </mt-index-section>
        </mt-index-list>
      </mt-popup>
      <!--时间弹窗-->
      <mt-datetime-picker
        ref="picker"
        type="date"
        :startDate='startTime'
        yearFormat="{value}年"
        monthFormat="{value}月"
        dateFormat="{value}日"
        v-model="pickerValue"
        @confirm="handleConfirm">
      </mt-datetime-picker>
      <div class="get_div">
        <button :class="[dis === true ? 'disabled':'']" @click="keepData()"><span>提交</span></button>
      </div>
    </div>
  </div>
</template>

<script>
import headTop from '../header/Header'
import {Toast, Indicator} from 'mint-ui'
import {getVillageLoad, searchKeyword} from '../../api/cityVillage'
import {addAreaSystem} from '../../api/my'

export default {
  name: 'addAreaSystem',
  data () {
    return {
      villageShow: false, // 小区弹窗
      nameShow: false, // 项目经理弹窗
      data: {}, // 获取小区列表数据
      keyword: '', // 搜索值
      nameArr: [], // 项目经理
      name: '', // 项目经理
      nameId: '', // 经理id
      villgeWord: '', // 小区名
      villgeId: '', // 小区id
      pickerValue: '', // 时间选择v-model的值
      endTime: '', // 选择结束时间
      // startTime: '请选择开始时间',
      sTime: '',
      startTime: '',
      type: 0,
      noResult: false,
      indexArr: [],
      dis: false // 防止按钮重复点击（false: 可点击  true：不可点击）
    }
  },
  created() {
    this.startTime = new Date()
  },
  computed: {
    dateSlots () {
      this.data1 = this.nameArr
      let slots = [
        {
          flex: 1,
          values: this.data1,
          className: 'slot1',
          textAlign: 'center'
        }
      ]
      return slots
    }
  },
  methods: {
    // 小区弹窗
    choiceVillage() {
      this.villageShow = true
      this._getVillage()
    },
    // 获取小区列表
    _getVillage () {
      getVillageLoad().then(res => {
        if (res.code === 200) {
          this.data = res.data
        }
      })
    },
    search () {
      searchKeyword(this.keyword).then(res => {
        if (res.code === 200) {
          this.data = res.data
        }
      })
    },
    goVillage (item) {
      this.villgeWord = item.title
      this.villgeId = item.id
      // console.log(this.villgeId)
      this.keyword = ''
      this.villageShow = false
    },
    // picker取消
    handleCache() {
      this.nameShow = false
    },

    // 开始时间
    openPicker (index) {
      this.indexArr = index
      this.$refs.picker.open()
    },
    handleConfirm (e) {
      this.endTime = this.formatDate(e)
    },
    // 时间转换
    formatDate(secs) {
      var t = new Date(secs)
      var year = t.getFullYear()
      var month = t.getMonth() + 1
      if (month < 10) { month = '0' + month }
      var date = t.getDate()
      if (date < 10) { date = '0' + date }
      var hour = t.getHours()
      if (hour < 10) { hour = '0' + hour }
      var minute = t.getMinutes()
      if (minute < 10) { minute = '0' + minute }
      var second = t.getSeconds()
      if (second < 10) { second = '0' + second }
      return year + '-' + month + '-' + date
    },
    // 选择项目经理
    keepData() {
      if (this.dis === false) {
        if (!this.villgeId) {
          Toast({
            message: '请选择小区！',
            position: 'middle',
            duration: 2000
          })
          return
        }
        if (!this.endTime) {
          Toast({
            message: '请选择结束时间！',
            position: 'middle',
            duration: 3000
          })
          return
        }
        this.dis = true
        Indicator.open({
          text: '..提交中..',
          spinnerType: 'fading-circle'
        })
        addAreaSystem(this.villgeId, this.endTime).then(res => {
          if (res.code === 200) {
            Toast({
              message: res.data,
              position: 'middle',
              duration: 2000
            })
            Indicator.close()
            this.$router.push('/ApplyRecord')
          }
          if (res.code === 400) {
            Toast({
              message: res.error,
              position: 'middle',
              duration: 2000
            })
            Indicator.close()
          }
        })
      }
    }
  },
  components: {
    headTop
  }
}
</script>

<style lang="scss" scoped>
@import "../../common/sass/mixin.scss";
.add_apply{
  padding-top: 50px;
  .add_main{
    padding: 10px;
    .choice_village{
      width: 98%;
      display: inline-flex;
      align-items: center;
      justify-content: space-between;
      .choice_left{
        display: inline-flex;
        align-items: center;
        span{
          font-size: 15px;
          color: #333333;
        }
        input{
          background: #ffffff;
          border: none;
          outline: none;
          font-size: 15px;
          padding: 10px 0;
          color: #999999;
        }
      }
      img{
        width: 8px;
        height: 15px;
        transform: rotate(90deg);
      }
    }
    .bas_time{
      .choice_left{
        display: -webkit-inline-box;
        align-items: center;
        width: 94.5%;
      }
      font-size: 15px;
      span{
        color: #333333;
      }
      input{
        background: white;
        outline: none;
        border: none;
        font-size: 15px;
        padding: 10px 0;
        color: #666666;
      }
      img{
        width: 8px;
        height: 15px;
        transform: rotate(90deg);
      }
    }
    .select_li{
      width: 100%;
      display: inline-flex;
      align-items: center;
      margin: 10px 0;
      span{
        font-size: 15px;
        color: #333333;
      }
      select{
        width: 120px;
        outline: none;
        padding: 5px 0;
        border: 1px solid #999999;
        color: #999999;
        option{
          font-size: 15px;
        }
      }
    }
    .get_div{
      padding: 10px 0;
      button{
        background: #0078de;
        outline: none;
        width: 100%;
        span {
          line-height: 44px;
          font-size: 15px;
          color: #fff;
        }
      }
      .disabled{
        background: #999999;
      }
    }
  }
  // 弹窗样式(小区)
  .villageHeights {
    width: 100%;
    border-radius: 5px;
    .village {
      .p {
        font-size: 15px;
        text-align: center;
        line-height: 39px;
      }
      .plot-wrapper {
        width: 100%;
        padding-top: 40px;
        background: #fff;
        .search {
          width: 100%;
          position: fixed;
          top: 40px;
          left: 0;
          background-color: #fff;
          text-align: center;
          height: 44px;
          line-height: 44px;
          .now-plot {
            padding-left: 10px;
            text-align: left;
            font-size: 15px;
            height: 40px;
            line-height: 40px;
            background-color: #D9D9D9;
          }
          .search-wrapper {
            display: inline-block;
            height: 30px;
            line-height: 30px;
            width: 80%;
            margin: 0 10px;
            border-radius: 4px;
            background-color: #e6e6e6;
            input {
              width: 118px;
              font-size: 14px;
              outline: none;
              border: none;
              background-color: #e6e6e6;
              &::-ms-input-placeholder {
                text-align: center;
              }
              &::-webkit-input-placeholder {
                text-align: center;
              }
            }
            .search-icon {
              display: inline-block;
              width: 17px;
              height: 17px;
              background-size: 17px 17px;
              background-repeat: no-repeat;
              @include bgimg('../../components/home/images/search');
              vertical-align: middle;
            }
          }
        }
      }
    }
    height: 90%;
    .mint-indexlist {
      height: 80%;
    }
    .mint-indexlist-content {
      height: 100% !important;
      -webkit-overflow-scrolling: touch;
      overflow-scrolling: touch;
    }
    .mint-cell-wrapper {
      background-size: 120% 0px;
    }
  }
  .nameHeights{
    /*width: 70%;
    height: 300px;
    border-radius: 5px;
    overflow-y: scroll;
    .name_popup{
      .name_li{
        border-bottom: 1px solid #e6e6e6;
        padding: 15px 0;
        text-align: center;
        font-size: 15px;
        color: #666666;
      }
    }*/
    width: 100%;
    .time_picker{
      .btn{
        font-size: 16px;
        height: 40px;
        line-height: 40px;
        padding: 0 20px;
        display: inline-block;
      }
      .btn_cancel{
        color: #666666;
      }
      .btn_sure{
        color: #0C7AD9;
        float: right;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/my/addAreaSystem.vue